export default function validEmail(email) {
    const isValidEmail = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g;
    return email?.match(isValidEmail);
}